import React, { FC } from 'react';
import useStyles from './styles';

interface INoDataInformation {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export const NoDataInformation: FC<INoDataInformation> = ({
  title,
  subtitle,
  children,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.informationWrapper}>
      <h2>{title}</h2>
      <p className={classes.informationParagraph}>{subtitle}</p>
      {children}
    </div>
  );
};

export default NoDataInformation;
